export const LOGIN_VARIANTS = {
  DEFAULT: "default",
  ELTE: "elte",
} as const;

export type LoginVariant = (typeof LOGIN_VARIANTS)[keyof typeof LOGIN_VARIANTS];

export function parseLoginVariant(raw: string | undefined): LoginVariant {
  const normalized = raw?.trim().toLowerCase();

  if (normalized === LOGIN_VARIANTS.ELTE) {
    return LOGIN_VARIANTS.ELTE;
  }

  if (normalized && normalized !== LOGIN_VARIANTS.DEFAULT) {
    console.warn(
      `[env] Unknown VITE_LOGIN_VARIANT "${normalized}" (raw: "${raw ?? ""}"), falling back to "default"`
    );
  }

  return LOGIN_VARIANTS.DEFAULT;
}

export function isElteLoginVariant(variant: LoginVariant): boolean {
  return variant === LOGIN_VARIANTS.ELTE;
}
